import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import ConfirmationPopupProps from "./confirmation-popup.props";
import DeleteIcon from "../../../assets/icons/delete.svg";
import ArchiveIcon from "../../../assets/icons/archive.svg";
import ClearIcon from "../../../assets/icons/cancel-icon.svg";
import InfoIcon from "../../../assets/icons/info.svg";
import CloseIcon from "../../../assets/icons/white-color-cancel-icon.svg";
import "./popup.scss";

const ConfirmationPopup: React.FC<ConfirmationPopupProps> = ({
  title,
  open,
  onCancel,
  onOkay,
  note,
  buttonText,
  showIcon = true,
  Icon,
  className,
  isDoNotSendButtonRequired = false,
  extraButtonText,
  onExtraButtonOkay,
  cancelBtnText = "Cancel",
  variant = "default",
  iconType = "delete",
}) => {
  const getIcon = () => {
    if (Icon) return Icon;
    switch (iconType) {
      case "archive":
        return ArchiveIcon;
      case "clear":
        return ClearIcon;
      case "info":
        return InfoIcon;
      default:
        return DeleteIcon;
    }
  };
  return (
    <>
      <Dialog
        open={open}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            onCancel();
          }
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={`confirmation-popup-wrapper ${className || ""}`}
      >
        <DialogTitle id="alert-dialog-title">
          <div className="header-wrapper">
            {showIcon ? (
              <div className="image-wrapper">
                <div
                  className="title-with-icon-confirmation-popup"
                  style={{ display: "flex", gap: "10px" }}
                >
                  <img
                    src={getIcon()}
                    className={`delete-icon ${
                      variant === "danger" ? "danger-icon" : ""
                    }`}
                  ></img>
                  <div style={{ margin: "auto" }}>{title}</div>
                </div>
                <img
                  src={CloseIcon}
                  className="close-icon"
                  onClick={onCancel}
                />
              </div>
            ) : (
              <div className="title-and-cancel-wrapper">
                <div>{title}</div>
                <img
                  src={CloseIcon}
                  className="close-icon"
                  onClick={onCancel}
                />
              </div>
            )}
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {note}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onCancel} className="cancel-btn">
            {cancelBtnText || "Cancel"}
          </Button>
          {isDoNotSendButtonRequired && (
            <Button onClick={onExtraButtonOkay} className="cancel-btn">
              {extraButtonText}
            </Button>
          )}
          <Button
            onClick={onOkay}
            autoFocus
            className={`action-btn ${variant === "danger" ? "danger-btn" : ""}`}
          >
            {buttonText}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ConfirmationPopup;
